import React from "react";
// components
import { ICustomWidgetTypeProps } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import { CustomWidgetTypes } from "../../../types";
import { MenuCategoryGrid } from "../../MenuCategoryGrid";
import { IMenuCategoryGrid } from "../../MenuCategoryGrid/types";
import { MenuPills } from "../../MenuPills";
import { IPillsProps } from "../../MenuPills/types";
import RefineWidget from "../../RefineWidget/RefineWidget";
import { IRefineWidget } from "../../RefineWidget/types";

export const customWidgetTypeHandler = (card: ICustomWidgetTypeProps) => {
    try {
        switch (card["@type"]) {
            case CustomWidgetTypes.MENU_CATEGORY_GRID:
                return <MenuCategoryGrid {...(card as IMenuCategoryGrid)} />;
            case CustomWidgetTypes.MENU_PARENT_CATEGORY_PILLS:
                return <MenuPills {...(card as IPillsProps)} />;
            case CustomWidgetTypes.REFINE_WIDGET:
                return <RefineWidget {...(card as unknown as IRefineWidget)} />;
            default:
                return null;
        }
    } catch (e) {
        throw new Error(`Error in customWidgetTypeHandler : ${JSON.stringify(e)}`);
    }
};
